<template>
  <div class="form-row" :class="info.dirty && info.invalid?'mb_50':''"
       :style="{background:isMobile && configStyle ?  configStyle.formRowBgColor: ''}">
    <div class="form-label"  :style="{color:isMobile && configStyle ? configStyle.formColor: ''}">{{ info.displayName }}</div>
    <div class="form-contro">
      <input
        :type="type || 'text'"
        class="form-input"
        v-model="info.value"
        @change="info.resetValue()"
        :disabled="info.disabled"
        placeholder="请填写"
        :style="{background:isMobile&&configStyle ? configStyle.formRowBgColor: '',color:isMobile&&configStyle ? configStyle.formColor: ''}"
      />
    </div>
    <div class="form-error" v-if="info.dirty && info.invalid">
      {{ info.validationMessage }}
    </div>
  </div>
</template>

<script>import { $subscriber } from "fire-wind-water/tools/subscriber";
import {interact} from "fire-wind-water/tools/interact";
export default {
  name: "SText",
  data() {
    return{
      configStyle:null,
      isMobile:false
    }
  },
  props: {
    info: {},
    type: null,
  },
  created() {
    $subscriber.subscribe("config-style", data=>{
      this.configStyle = data;
    });
    if (interact.isMobile == 1){
      this.isMobile = true
    }
  }
};
</script>

<style scoped></style>
